
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ksNs6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e6df6f5a0cb7a26e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4J0ad = parcelRequire("4J0ad");

var $ezGpi = parcelRequire("ezGpi");

var $kfoSY = parcelRequire("kfoSY");

var $2QUmO = parcelRequire("2QUmO");

var $fcM2a = parcelRequire("fcM2a");

var $9pWNg = parcelRequire("9pWNg");

var $6PAED = parcelRequire("6PAED");

var $em3rG = parcelRequire("em3rG");

var $jCQRh = parcelRequire("jCQRh");

var $eu0Ha = parcelRequire("eu0Ha");
var /* Using withAnalyticsEvents HOC instead of ComponentWithAnalytics so we can fire on the
 * navigation channel and add actionSubjectId and attributes easily.
 * The withAnalyticsEvents HOC must wrap keyboardShortcuts first so it does not override any injected
 * props. */ $e6df6f5a0cb7a26e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.memo)((0, $2QUmO.default)((0, $4J0ad.default)({
    showSearch: (createAnalyticsEvent)=>(0, $kfoSY.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'quickSearch',
            key: '/'
        }),
    showIssueCreate: (createAnalyticsEvent)=>(0, $kfoSY.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'createIssue',
            key: 'c'
        }),
    navigateToIssueSearch: (createAnalyticsEvent)=>(0, $kfoSY.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'findIssues',
            key: 'g i'
        }),
    navigateToMostRecentProject: (createAnalyticsEvent)=>(0, $kfoSY.keyboardShortcutPressed)({
            createAnalyticsEvent: createAnalyticsEvent,
            id: 'browseToProject',
            key: 'g p'
        })
})((0, $eu0Ha.default)), {
    navigateToIssueSearch: $em3rG.navigateToIssueSearch,
    navigateToMostRecentProject: $em3rG.navigateToMostRecentProject,
    ApplicationPermissionsSubscriber: $6PAED.ApplicationPermissionsSubscriber,
    KeyboardShortcutsDialog: $jCQRh.KeyboardShortcutsDialog,
    ProjectCreateDrawerConsumer: $9pWNg.ProjectCreateDrawerConsumer,
    Shortcuts: $ezGpi.CommandShortcuts,
    NavUIControllerSubscriber: $fcM2a.UIControllerSubscriber
}));

});
parcelRegister("ezGpi", function(module, exports) {
$parcel$export(module.exports, "CommandShortcuts", () => $1e305c509eaf0223$export$7ff7e4fe85a5960a);

var $eJOHy = parcelRequire("eJOHy");

var $fWwfy = parcelRequire("fWwfy");

var $73jrx = parcelRequire("73jrx");

var $hf4h9 = parcelRequire("hf4h9");

var $fo3wk = parcelRequire("fo3wk");
const $1e305c509eaf0223$export$7ff7e4fe85a5960a = (props)=>{
    const { keyMap: keyMap } = props;
    const mappedCommands = (0, $eJOHy.useMemo)(()=>{
        const commands = [];
        Object.entries(keyMap).forEach(([key, mapItem])=>{
            if (!mapItem.registerInCommandPalette) return;
            const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
            let shortcutPrimaryAction;
            if (primaryAction?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST || primaryAction?.type === (0, $hf4h9.CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
            else if (mapItem.callback) shortcutPrimaryAction = {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>mapItem.callback()
            };
            /**
			 * loadChildren function has the preference over the other actions
			 * followed by perform and then, if none set, the KeyMap callback
			 */ commands.push({
                id: `command-shortcut-${key}`,
                shortcut: key,
                ...command,
                primaryAction: shortcutPrimaryAction
            });
        });
        return commands;
    }, [
        keyMap
    ]);
    /**
	 * As mappedCommands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const shortcutIds = (0, $eJOHy.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
        mappedCommands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), props), !!mappedCommands.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $73jrx.RegisterCommands), {
        registrationId: (0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
        commands: mappedCommands,
        deps: [
            shortcutIds
        ]
    }));
};

});
parcelRegister("73jrx", function(module, exports) {
$parcel$export(module.exports, "RegisterCommands", () => $54ccbd2a3c61da6a$export$cd555833c78729f1);

var $eJOHy = parcelRequire("eJOHy");

var $3DnU9 = parcelRequire("3DnU9");
const $54ccbd2a3c61da6a$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3DnU9.RegisterCommandsWithRegistry), props);

});
parcelRegister("3DnU9", function(module, exports) {
$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $c82e68fcec934ed3$export$b8955a01360d2876);

var $cQKVu = parcelRequire("cQKVu");
function $c82e68fcec934ed3$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $cQKVu.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});


parcelRegister("fo3wk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4454c8bb14df47ef$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $hrKgE = parcelRequire("hrKgE");

var $9ltuT = parcelRequire("9ltuT");

var $lObif = parcelRequire("lObif");

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");

var $4B7rn = parcelRequire("4B7rn");

var $8gJRB = parcelRequire("8gJRB");
let $4454c8bb14df47ef$var$shortcutsCount = 0;
let $4454c8bb14df47ef$var$subscription = null;
const $4454c8bb14df47ef$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eJOHy.useContext)((0, $4B7rn.ShortcutRegistryContext)) || (0, $d94A4.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const addKeyMap = (0, $eJOHy.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $8gJRB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $4454c8bb14df47ef$var$shortcutsCount -= 1;
            if ($4454c8bb14df47ef$var$subscription && $4454c8bb14df47ef$var$shortcutsCount === 0) {
                $4454c8bb14df47ef$var$subscription.unsubscribe();
                $4454c8bb14df47ef$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eJOHy.useEffect)(()=>{
        $4454c8bb14df47ef$var$subscription = $4454c8bb14df47ef$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $5R5jr.default)().subscribe((0, $lObif.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
const $4454c8bb14df47ef$var$Shortcuts = ({ useKeyboardShortcutsToggle: // eslint-disable-next-line react-hooks/react-compiler
useKeyboardShortcutsToggle = (0, $9ltuT.useKeyboardShortcutsToggle), ...unstableProps })=>{
    // eslint-disable-next-line react-hooks/react-compiler
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, true);
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4454c8bb14df47ef$var$ShortcutsSubscriber, props) : null;
};
var $4454c8bb14df47ef$export$2e2bcd8739ae039 = $4454c8bb14df47ef$var$Shortcuts;

});
parcelRegister("9ltuT", function(module, exports) {
$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $08e42e851d357ae1$export$a33a81f1fc5458ad);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $hWeHP = parcelRequire("hWeHP");

var $kRgKj = parcelRequire("kRgKj");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $08e42e851d357ae1$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $08e42e851d357ae1$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$08e42e851d357ae1$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $3ugTQ.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $08e42e851d357ae1$var$Store = (0, $GtRbT.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $hWeHP.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $08e42e851d357ae1$export$b62f67be35e65859
    }
});
const $08e42e851d357ae1$export$a33a81f1fc5458ad = (0, $iJq0l.createHook)($08e42e851d357ae1$var$Store);

});

parcelRegister("lObif", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6eea6b4ddedc8b9$export$2e2bcd8739ae039);

var $5R5jr = parcelRequire("5R5jr");

var $d94A4 = parcelRequire("d94A4");
const $f6eea6b4ddedc8b9$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
/**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ const $f6eea6b4ddedc8b9$var$handler = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $d94A4.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $5R5jr.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f6eea6b4ddedc8b9$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $5R5jr.flush)();
    }
};
var $f6eea6b4ddedc8b9$export$2e2bcd8739ae039 = $f6eea6b4ddedc8b9$var$handler;

});
parcelRegister("5R5jr", function(module, exports) {
$parcel$export(module.exports, "flush", () => $6bc56ab68fad194d$export$4909b86c8034bf73);
$parcel$export(module.exports, "default", () => $6bc56ab68fad194d$export$2e2bcd8739ae039);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $7kixv = parcelRequire("7kixv");

var $6WhQS = parcelRequire("6WhQS");
parcelRequire("7SsGX");
parcelRequire("hnYRz");
parcelRequire("llumX");
parcelRequire("lVRem");
parcelRequire("1o2WJ");
parcelRequire("8rm0O");
parcelRequire("9Zsih");
parcelRequire("lf3vd");

var $gPrdS = parcelRequire("gPrdS");

var $6ju76 = parcelRequire("6ju76");
const $6bc56ab68fad194d$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $6bc56ab68fad194d$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$6bc56ab68fad194d$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6bc56ab68fad194d$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$6bc56ab68fad194d$var$isEditable(e.target) && !$6bc56ab68fad194d$var$ignoredKeys[e.key]);
let $6bc56ab68fad194d$var$key$;
const $6bc56ab68fad194d$var$flush$ = new (0, $6WhQS.Subject)();
const $6bc56ab68fad194d$var$createSequences = ()=>{
    if (!$6bc56ab68fad194d$var$key$) {
        $6bc56ab68fad194d$var$key$ = false ? new (0, $6WhQS.Subject)() : (0, $7kixv.Observable).fromEvent(document, 'keydown').filter($6bc56ab68fad194d$var$isRelevantKeyEvent).filter((0, $6ju76.isLegacyAuiBlanketClosed)).map((0, $gPrdS.toKeyWithModifiers));
        const sequence$ = $6bc56ab68fad194d$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $6bc56ab68fad194d$var$key$ = $6bc56ab68fad194d$var$key$.debounceTime(1000).startWith(null).merge($6bc56ab68fad194d$var$flush$).switchMapTo(sequence$);
    }
    return $6bc56ab68fad194d$var$key$;
};
const $6bc56ab68fad194d$export$4909b86c8034bf73 = ()=>{
    $6bc56ab68fad194d$var$flush$.next();
};
var $6bc56ab68fad194d$export$2e2bcd8739ae039 = $6bc56ab68fad194d$var$createSequences;

});


parcelRegister("8gJRB", function(module, exports) {
$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $91e416a701a8c178$export$77477772a9b904da);

var $eSnSE = parcelRequire("eSnSE");

var $kRgKj = parcelRequire("kRgKj");

var $4cTDP = parcelRequire("4cTDP");
const $91e416a701a8c178$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $4cTDP.fg)('log-hotkey-analytics')) (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $91e416a701a8c178$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $91e416a701a8c178$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});



parcelRegister("kfoSY", function(module, exports) {
$parcel$export(module.exports, "keyboardShortcutPressed", () => $388452f1fc1d2d3a$export$32c6c6b79f098d3);
$parcel$export(module.exports, "productNavigationExpandedCollapsed", () => $388452f1fc1d2d3a$export$e2ad10d5be2f2400);
/**
 * This file contains analytics functions related to navigation keyboard shortcuts.
 * We are firing events on the navigation fabric channel to align with the other events
 * specified in https://hello.atlassian.net/wiki/spaces/PData/pages/140331306/Minimum+Event+Spec+-+Navigation
 * These functions are used in both nav v1 and nav v2 at the moment with a long term goal of moving global navigation
 * keyboard shortcuts within atlaskit itself.
 */ 
var $3VCQy = parcelRequire("3VCQy");
const $388452f1fc1d2d3a$export$32c6c6b79f098d3 = ({ createAnalyticsEvent: createAnalyticsEvent, id: id, key: key, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut',
        actionSubjectId: id,
        attributes: {
            // @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState attribute is used instead
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            navVersion: window.__NAV_VERSION__ || 'UNKNOWN',
            key: key,
            ...attributes
        }
    }).fire((0, $3VCQy.FabricChannel).navigation);
};
const $388452f1fc1d2d3a$export$e2ad10d5be2f2400 = ({ createAnalyticsEvent: createAnalyticsEvent, isCollapsed: isCollapsed })=>{
    createAnalyticsEvent({
        action: isCollapsed ? 'expanded' : 'collapsed',
        actionSubject: 'productNavigation',
        attributes: {
            trigger: 'keyboardShortcut'
        }
    }).fire((0, $3VCQy.FabricChannel).navigation);
};

});

parcelRegister("fcM2a", function(module, exports) {
$parcel$export(module.exports, "UIControllerSubscriber", () => $460351244107c238$export$8e3db525e646de2c);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $9Sckd = parcelRequire("9Sckd");

var $f2JN3 = parcelRequire("f2JN3");

var $cUxaS = parcelRequire("cUxaS");

var $6zXPf = parcelRequire("6zXPf");
// Nav3
const $460351244107c238$var$UIControllerSubscriberOld = ({ children: children })=>{
    const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $cUxaS.useLeftSidebarController)();
    const { isCollapsed: isCollapsed, width: width } = (0, $cUxaS.useLeftSidebarState)();
    const stateRef = (0, $eJOHy.useRef)({
        state: {
            isCollapsed: isCollapsed,
            isResizing: false,
            isResizeDisabled: false,
            productNavWidth: width
        },
        collapse: collapseLeftSidebar,
        expand: expandLeftSidebar,
        toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
    });
    const navigationUIController = (0, $eJOHy.useMemo)(()=>({
            state: {
                isCollapsed: isCollapsed,
                isResizing: false,
                isResizeDisabled: false,
                productNavWidth: width
            },
            collapse: collapseLeftSidebar,
            expand: expandLeftSidebar,
            toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
        }), [
        collapseLeftSidebar,
        expandLeftSidebar,
        isCollapsed,
        width
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $460351244107c238$var$defaultState = {
    state: {
        isCollapsed: false,
        isResizing: false,
        isResizeDisabled: false,
        productNavWidth: 0
    },
    collapse: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    expand: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    toggleCollapse: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
// Nav4
const $460351244107c238$var$UIControllerSubscriberNew = ({ children: children })=>{
    const toggleSideNav = (0, $9Sckd.useToggleSideNav)();
    const stateRef = (0, $eJOHy.useRef)({
        ...$460351244107c238$var$defaultState,
        toggleCollapse: toggleSideNav
    });
    const navigationUIController = (0, $eJOHy.useMemo)(()=>({
            ...$460351244107c238$var$defaultState,
            toggleCollapse: toggleSideNav
        }), [
        toggleSideNav
    ]);
    stateRef.current = Object.assign(stateRef.current, navigationUIController);
    return children(stateRef.current);
};
const $460351244107c238$export$8e3db525e646de2c = (0, $f2JN3.componentWithCondition)((0, $6zXPf.getWillShowNav4), $460351244107c238$var$UIControllerSubscriberNew, $460351244107c238$var$UIControllerSubscriberOld);

});

parcelRegister("em3rG", function(module, exports) {
$parcel$export(module.exports, "ISSUE_SEARCH_PATH", () => $73e2c0070287e622$export$160e2509706f1f3d);
$parcel$export(module.exports, "navigateToIssueSearch", () => $73e2c0070287e622$export$722548870edd83a4);
$parcel$export(module.exports, "navigateToMostRecentProject", () => $73e2c0070287e622$export$6e7d070c02020dbd);

var $3ugTQ = parcelRequire("3ugTQ");
const $73e2c0070287e622$export$160e2509706f1f3d = '/issues/';
const $73e2c0070287e622$export$722548870edd83a4 = ()=>window.open($73e2c0070287e622$export$160e2509706f1f3d, '_self');
const $73e2c0070287e622$export$6e7d070c02020dbd = ()=>(0, $3ugTQ.performGetRequest)('/rest/internal/2/productsearch/search?type=projects').then((data)=>{
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
        const section = data.find(({ id: id })=>id === 'quick-search-projects');
        if (section && section.items && section.items[0] && section.items[0].url) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(section.items[0].url, '_self');
    });

});

parcelRegister("jCQRh", function(module, exports) {
$parcel$export(module.exports, "KeyboardShortcutsDialog", () => $6ef8300e597c6d12$export$dc5d1c021e0a8741);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6ef8300e597c6d12$var$KeyboardShortcutsDialogLazy = (0, $bQWwW.lazy)(()=>(parcelRequire("2iwf7")), {
    ssr: false,
    moduleId: "./src/packages/common/components/keyboard-shortcuts-dialog/src/index.tsx"
});
const $6ef8300e597c6d12$export$dc5d1c021e0a8741 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "integrations.keyboard-shortcuts-dialog",
        packageName: "jira-keyboard-shortcuts",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "keyboard-shortcuts.dialog",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6ef8300e597c6d12$var$KeyboardShortcutsDialogLazy, props)));

});
parcelRegister("2iwf7", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5N8v4").then(()=>parcelRequire('buotH'));

});


parcelRegister("eu0Ha", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea396fab7f69d4bd$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dcLzM = parcelRequire("dcLzM");

var $ePxSL = parcelRequire("ePxSL");

var $6WP1Q = parcelRequire("6WP1Q");

var $8mxGC = parcelRequire("8mxGC");

var $cxKOj = parcelRequire("cxKOj");

var $1Zcfy = parcelRequire("1Zcfy");

var $kQy7N = parcelRequire("kQy7N");

var $ii7Oz = parcelRequire("ii7Oz");

var $itdlt = parcelRequire("itdlt");

var $kfoSY = parcelRequire("kfoSY");

var $4cTDP = parcelRequire("4cTDP");


var $kDaaB = parcelRequire("kDaaB");
var $lRq8t = parcelRequire("lRq8t");

var $5Ste8 = parcelRequire("5Ste8");

var $6nVJI = parcelRequire("6nVJI");

var $hrKgE = parcelRequire("hrKgE");

var $em3rG = parcelRequire("em3rG");


var $52o2P = parcelRequire("52o2P");

var $2UiCp = parcelRequire("2UiCp");
const $ea396fab7f69d4bd$var$KeyboardShortcuts = /*#__PURE__*/ (0, $eJOHy.memo)(({ navigateToIssueSearch: navigateToIssueSearch, navigateToMostRecentProject: navigateToMostRecentProject, showIssueCreate: showIssueCreate, showSearch: showSearch, shouldUseHelpShortcut: shouldUseHelpShortcut, formatMessage: formatMessage, getKeywords: getKeywords, createAnalyticsEvent: createAnalyticsEvent, toggleHelpPanel: toggleHelpPanelFromProps, hideAndTransformNavigationCommand: hideAndTransformNavigationCommand, ApplicationPermissionsSubscriber: ApplicationPermissionsSubscriber, KeyboardShortcutsDialog: KeyboardShortcutsDialog, ProjectCreateDrawerConsumer: ProjectCreateDrawerConsumer, Shortcuts: Shortcuts, NavUIControllerSubscriber: NavUIControllerSubscriber })=>{
    const getKeymap = (0, $eJOHy.useCallback)(({ toggleHelpPanel: toggleHelpPanel, openKeyboardShortcutsDialog: openKeyboardShortcutsDialog, toggleCollapse: toggleCollapse, isNextGen: isNextGen })=>{
        const keys = isNextGen === true ? {
            '?': {
                callback: openKeyboardShortcutsDialog,
                registerInCommandPalette: {
                    name: formatMessage((0, $52o2P.default).keyboardShortcutsCommandPalette),
                    keywords: getKeywords('viewKeyboardShortcutsSynonyms'),
                    priority: (0, $1Zcfy.COMMAND_PALETTE_HELP_PRIORITY).viewKeyboardShortcuts,
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).help,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6WP1Q))), {
                                spacing: "spacious",
                                label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $52o2P.default).keyboardShortcutsCommandPalette),
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    analytics: {
                        action: (0, $2e00a4e32dbdece8$export$e0515b3bb1ce3f33)
                    },
                    id: 'keyboard-shortcuts.open'
                }
            },
            '/': {
                callback: showSearch
            },
            '[': {
                callback: toggleCollapse
            },
            escape: {
                // taken care of by the @atlaskit/drawer component itself
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{}
            },
            'g p': {
                callback: ()=>navigateToMostRecentProject()
            },
            'g i': {
                callback: ()=>navigateToIssueSearch(),
                registerInCommandPalette: hideAndTransformNavigationCommand({
                    command: {
                        id: 'find-issues',
                        name: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).viewAllIssuesIssueTermRefresh : (0, $52o2P.default).viewAllIssues),
                        keywords: getKeywords('viewAllIssuesSynonyms'),
                        priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewAllIssues,
                        section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                                    spacing: "spacious",
                                    label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).viewAllIssuesIssueTermRefresh : (0, $52o2P.default).viewAllIssues),
                                    "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                                })
                        },
                        analytics: {
                            action: (0, $2e00a4e32dbdece8$export$5f007fc3736b8e2b)
                        }
                    },
                    hideCommandPath: (0, $em3rG.ISSUE_SEARCH_PATH),
                    path: (0, $em3rG.ISSUE_SEARCH_PATH)
                })
            },
            c: {
                callback: showIssueCreate,
                registerInCommandPalette: {
                    name: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).createIssueIssueTermRefresh : (0, $52o2P.default).createIssue),
                    keywords: getKeywords('createIssueSynonyms'),
                    priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).createIssue,
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                                spacing: "spacious",
                                label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).createIssueIssueTermRefresh : (0, $52o2P.default).createIssue),
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    analytics: {
                        action: (0, $2e00a4e32dbdece8$export$4e353cf4f7beb2cd)
                    },
                    id: 'keyboard-shortcuts.create-issue'
                }
            },
            ...shouldUseHelpShortcut && __SPA__ ? {
                h: {
                    callback: toggleHelpPanel,
                    registerInCommandPalette: {
                        name: formatMessage((0, $52o2P.default).getHelp),
                        keywords: getKeywords('getHelpSynonyms'),
                        priority: (0, $1Zcfy.COMMAND_PALETTE_HELP_PRIORITY).getHelp,
                        section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).help,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mxGC))), {
                                    spacing: "spacious",
                                    label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $52o2P.default).getHelp),
                                    "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                                })
                        },
                        analytics: {
                            action: (0, $2e00a4e32dbdece8$export$42dbd0c9d165bb55)
                        },
                        id: 'keyboard-shortcuts.help'
                    }
                }
            } : null
        } : {
            '/': {
                callback: showSearch,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $52o2P.default).quickSearch)
            },
            escape: {
                // taken care of by the @atlaskit/drawer component itself
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{},
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $52o2P.default).closeDrawer)
            },
            c: {
                callback: showIssueCreate,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).createIssueIssueTermRefresh : (0, $52o2P.default).createIssue),
                registerInCommandPalette: {
                    name: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).createIssueIssueTermRefresh : (0, $52o2P.default).createIssue),
                    keywords: getKeywords('createIssueSynonyms'),
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
                    priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).createIssue,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))), {
                                spacing: "spacious",
                                label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).createIssueIssueTermRefresh : (0, $52o2P.default).createIssue),
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    analytics: {
                        action: (0, $2e00a4e32dbdece8$export$4e353cf4f7beb2cd)
                    },
                    id: 'keyboard-shortcuts.create-issue'
                }
            },
            '?': {
                callback: openKeyboardShortcutsDialog,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $52o2P.default).keyboardShortcuts),
                registerInCommandPalette: {
                    name: formatMessage((0, $52o2P.default).keyboardShortcutsCommandPalette),
                    keywords: getKeywords('viewKeyboardShortcutsSynonyms'),
                    priority: (0, $1Zcfy.COMMAND_PALETTE_HELP_PRIORITY).viewKeyboardShortcuts,
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).help,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6WP1Q))), {
                                spacing: "spacious",
                                label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $52o2P.default).keyboardShortcutsCommandPalette),
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    analytics: {
                        action: (0, $2e00a4e32dbdece8$export$e0515b3bb1ce3f33)
                    },
                    id: 'keyboard-shortcuts.open'
                }
            },
            'g i': {
                callback: ()=>navigateToIssueSearch(),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).findIssuesIssueTermRefresh : (0, $52o2P.default).findIssues),
                registerInCommandPalette: hideAndTransformNavigationCommand({
                    command: {
                        id: 'find-issues',
                        name: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).viewAllIssuesIssueTermRefresh : (0, $52o2P.default).viewAllIssues),
                        keywords: getKeywords('viewAllIssuesSynonyms'),
                        priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewAllIssues,
                        section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                                    spacing: "spacious",
                                    label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $52o2P.default).viewAllIssuesIssueTermRefresh : (0, $52o2P.default).viewAllIssues),
                                    "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                                })
                        },
                        analytics: {
                            action: (0, $2e00a4e32dbdece8$export$5f007fc3736b8e2b)
                        }
                    },
                    hideCommandPath: (0, $em3rG.ISSUE_SEARCH_PATH),
                    path: (0, $em3rG.ISSUE_SEARCH_PATH)
                })
            },
            'g p': {
                callback: ()=>navigateToMostRecentProject(),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $52o2P.default).browseAProjectGalaxia : (0, $52o2P.default).browseAProject)
            },
            '[': {
                callback: toggleCollapse,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $52o2P.default).toggleSidebar)
            },
            ...shouldUseHelpShortcut && __SPA__ ? {
                h: {
                    callback: toggleHelpPanel,
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $52o2P.default).openHelpPanel),
                    registerInCommandPalette: {
                        name: formatMessage((0, $52o2P.default).getHelp),
                        keywords: getKeywords('getHelpSynonyms'),
                        priority: (0, $1Zcfy.COMMAND_PALETTE_HELP_PRIORITY).getHelp,
                        section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).help,
                        components: {
                            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mxGC))), {
                                    spacing: "spacious",
                                    label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $52o2P.default).getHelp),
                                    "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                                })
                        },
                        analytics: {
                            action: (0, $2e00a4e32dbdece8$export$42dbd0c9d165bb55)
                        },
                        id: 'keyboard-shortcuts.help'
                    }
                }
            } : null,
            [`${(0, $2UiCp.getShortcutModifierKey)()}+k`]: {
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                callback: ()=>{},
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $52o2P.default).openCommandPalette),
                priority: -1 // this keyboard shortcut is only registered here to show up in the helper dialog. Its registration is in @atlassian/jira-command-palette-integration
            }
        };
        return keys;
    }, [
        formatMessage,
        getKeywords,
        hideAndTransformNavigationCommand,
        navigateToIssueSearch,
        navigateToMostRecentProject,
        shouldUseHelpShortcut,
        showIssueCreate,
        showSearch
    ]);
    const createToggleCollapse = (0, $eJOHy.useCallback)((navAPI)=>{
        return ()=>{
            const { state: { isCollapsed: isCollapsed }, toggleCollapse: toggleCollapse } = navAPI;
            (0, $kfoSY.keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'expandCollapseSidebar',
                key: '['
            });
            (0, $kfoSY.productNavigationExpandedCollapsed)({
                createAnalyticsEvent: createAnalyticsEvent,
                isCollapsed: isCollapsed
            });
            toggleCollapse();
        };
    }, [
        createAnalyticsEvent
    ]);
    const createToggleHelpPanel = (0, $eJOHy.useCallback)((isNextGen)=>{
        return ()=>{
            (0, $kfoSY.keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'openHelpPanel',
                key: 'h',
                attributes: {
                    helpPanelVersion: (0, $60b564818f0d5fed$export$c43c7444da662fa1),
                    helpPanelType: 'inProductHelp',
                    nextGenProject: isNextGen
                }
            });
            toggleHelpPanelFromProps();
        };
    }, [
        createAnalyticsEvent,
        toggleHelpPanelFromProps
    ]);
    const createOpenKeyboardShortcutsDialog = (0, $eJOHy.useCallback)((openDialog)=>{
        return ()=>{
            (0, $kfoSY.keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'keyboardShortcuts',
                key: '?'
            });
            openDialog();
        };
    }, [
        createAnalyticsEvent
    ]);
    return(// @ts-expect-error - TS2745 - This JSX tag's 'children' prop expects type 'never' which requires multiple children, but only a single child was provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ApplicationPermissionsSubscriber, null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ProjectCreateDrawerConsumer, null, ({ data: { isOpen: isOpen } })=>isOpen ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ste8.ModalsContainer), {
                scope: "keyboard-shortcuts"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ste8.ModalsSubscriber), null, (isKeyboardShortcutsDialogOpen, { open: open, close: close })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6nVJI.ContainerContextSubscriber), null, ({ data: contextData })=>{
                    const isNextGen = contextData && contextData.contextType === 'project' ? contextData.project.isSimplified : false;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, isKeyboardShortcutsDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(KeyboardShortcutsDialog, {
                        isOpen: true,
                        onDialogDismissed: close,
                        applicationPermissionData: data.applicationPermissions,
                        isNextGen: isNextGen,
                        shouldUseHelpShortcut: true
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(NavUIControllerSubscriber, null, (navAPI)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ea396fab7f69d4bd$var$ShortcutsInner, {
                            getKeymap: getKeymap,
                            navAPI: navAPI,
                            isNextGen: isNextGen,
                            createToggleHelpPanel: createToggleHelpPanel,
                            createOpenKeyboardShortcutsDialog: createOpenKeyboardShortcutsDialog,
                            open: open,
                            createToggleCollapse: createToggleCollapse,
                            Shortcuts: Shortcuts
                        })));
                }))))));
});
const $ea396fab7f69d4bd$var$ShortcutsInner = /*#__PURE__*/ (0, $eJOHy.memo)(({ getKeymap: getKeymap, navAPI: navAPI, isNextGen: isNextGen, createToggleHelpPanel: createToggleHelpPanel, createOpenKeyboardShortcutsDialog: createOpenKeyboardShortcutsDialog, open: open, createToggleCollapse: createToggleCollapse, Shortcuts: Shortcuts })=>{
    const keyMap = (0, $eJOHy.useMemo)(()=>getKeymap({
            toggleHelpPanel: createToggleHelpPanel(isNextGen),
            openKeyboardShortcutsDialog: createOpenKeyboardShortcutsDialog(open),
            toggleCollapse: createToggleCollapse(navAPI),
            isNextGen: isNextGen
        }), [
        getKeymap,
        createToggleHelpPanel,
        isNextGen,
        createOpenKeyboardShortcutsDialog,
        open,
        createToggleCollapse,
        navAPI
    ]);
    const label = (0, $eJOHy.useMemo)(()=>isNextGen ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $52o2P.default).globalShortcuts), [
        isNextGen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Shortcuts, {
        isSpa: __SPA__,
        label: label,
        keyMap: keyMap
    });
});
const $ea396fab7f69d4bd$export$89fa8f7790ea1f0e = (unstableProps)=>{
    const props = (0, $hrKgE.useShallowStableReference)(unstableProps, true);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { hideAndTransformNavigationCommand: hideAndTransformNavigationCommand } = (0, $kQy7N.useTransformNavigationCommands)();
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ea396fab7f69d4bd$var$KeyboardShortcuts, {
        formatMessage: formatMessage,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        getKeywords: getKeywords,
        ...props
    });
};
var $ea396fab7f69d4bd$export$2e2bcd8739ae039 = $ea396fab7f69d4bd$export$89fa8f7790ea1f0e;

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("6WP1Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f0917f4199f5ead8e2ff316703c32c4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50efbe1b581ab665$var$_react = $50efbe1b581ab665$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $50efbe1b581ab665$var$_baseNew = $50efbe1b581ab665$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $50efbe1b581ab665$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextStyle".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for text styles in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50efbe1b581ab665$var$TextStyleIcon = (props)=>/*#__PURE__*/ $50efbe1b581ab665$var$_react.default.createElement($50efbe1b581ab665$var$_baseNew.default, Object.assign({
        name: "TextStyleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.799.484A.75.75 0 0 1 7.5 0h1.018a.75.75 0 0 1 .701.485l3.733 9.875a.8.8 0 0 1 .048.265V11h-1.5v-.238L10.456 8H5.55L4.5 10.763V11H3v-.375a.8.8 0 0 1 .049-.266zM6.119 6.5h3.77L8.01 1.524z" clip-rule="evenodd"/>`
    }, props));
$50efbe1b581ab665$var$TextStyleIcon.displayName = 'TextStyleIcon';
var $50efbe1b581ab665$var$_default = module.exports.default = $50efbe1b581ab665$var$TextStyleIcon;

});

parcelRegister("kQy7N", function(module, exports) {
$parcel$export(module.exports, "useTransformNavigationCommands", () => $ae31bfa49fe3c190$export$5b108cd54c923a60);

var $eJOHy = parcelRequire("eJOHy");

var $58ssj = parcelRequire("58ssj");

var $ftN6c = parcelRequire("ftN6c");

var $9itkV = parcelRequire("9itkV");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $hf4h9 = parcelRequire("hf4h9");

var $jmeeg = parcelRequire("jmeeg");

var $2OtIa = parcelRequire("2OtIa");

var $g51Bg = parcelRequire("g51Bg");

var $kRgKj = parcelRequire("kRgKj");

var $6XJko = parcelRequire("6XJko");

var $gCY1z = parcelRequire("gCY1z");

var $4cTDP = parcelRequire("4cTDP");

var $7rOkc = parcelRequire("7rOkc");

var $cZPxL = parcelRequire("cZPxL");

var $9LFHG = parcelRequire("9LFHG");

var $aUXni = parcelRequire("aUXni");

const $ae31bfa49fe3c190$export$5b108cd54c923a60 = ()=>{
    const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, $gCY1z.useRouter)();
    const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, $g51Bg.useActionsCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const openNewTab = (0, $eJOHy.useCallback)((link, openBackground)=>{
        const url = typeof link === 'string' ? link : link.path;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const newTab = window.open(url, '_blank');
        if (openBackground) {
            newTab?.blur();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.focus();
        }
        return newTab;
    }, []);
    const openSameTab = (0, $eJOHy.useCallback)((link)=>{
        if (typeof link === 'string') return push(link);
        return pushTo(link);
    }, [
        push,
        pushTo
    ]);
    const renderCommand = (0, $eJOHy.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
        const { onClick: onClick, ...rest } = props;
        const { command: command } = rest;
        const handleClick = (event)=>{
            const wasSecondaryTriggered = (0, $2OtIa.isSecondaryTrigger)(event);
            if (!wasSecondaryTriggered) {
                onClick?.(event); // Run main action as it will close the modal too
                event.preventDefault();
                return;
            }
            const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
            const eventAnalytics = createAnalyticsEvent({});
            (0, $kRgKj.fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
            (0, $kRgKj.fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                ...analytics,
                keyPressed: (0, $58ssj.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                secondaryAction: 'openNewTab'
            });
            (0, $kRgKj.fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZPxL.NavigationLink), {
            to: path,
            onClick: handleClick,
            ...shouldAlwaysOpenNewTab && {
                target: '_blank'
            },
            "data-testid": (0, $5c6484dc0a85adf4$export$8db96ea7b6a4cbab),
            ...props.isLinkFocused && (0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility') && {
                isLinkFocused: props.isLinkFocused
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmeeg.components).CommandRow, rest));
    }, [
        createAnalyticsEvent,
        getAnalyticsAttributes
    ]);
    const transformNavigationCommand = (0, $eJOHy.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
            ...command,
            components: {
                ...command.components,
                Name: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rOkc.NameContainer), null, command.components?.Name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.Name, base) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
                        testId: (0, $5c6484dc0a85adf4$export$99957d8f5f113509),
                        justifyContent: "center",
                        alignItems: "center",
                        xcss: $ae31bfa49fe3c190$var$iconWrapperStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                        label: "",
                        color: "currentColor"
                    })), !!shouldAlwaysOpenNewTab && !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rOkc.IconContainer), {
                        "data-testid": (0, $5c6484dc0a85adf4$export$99957d8f5f113509)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                        label: "",
                        color: "currentColor"
                    }))),
                CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                Footer: (0, $9LFHG.NewTabHintMessage)
            },
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
            },
            secondaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>openNewTab(path, true),
                preventModalClose: true,
                analyticsArgs: {
                    secondaryAction: 'openNewTab'
                }
            }
        }), [
        openNewTab,
        openSameTab,
        renderCommand
    ]);
    const shouldShowCommand = (0, $eJOHy.useCallback)((hideCommandPath)=>!(0, $aUXni.isCurrentPage)(hideCommandPath, pathname), [
        pathname
    ]);
    const hideAndTransformNavigationCommand = (0, $eJOHy.useCallback)((commandToTransform)=>{
        const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
        let hidePath = typeof path === 'string' ? path : path.path;
        if (hideCommandPath) hidePath = hideCommandPath;
        if (!shouldShowCommand(hidePath)) return undefined;
        return transformNavigationCommand(command, {
            path: path,
            shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
        });
    }, [
        shouldShowCommand,
        transformNavigationCommand
    ]);
    const hideAndTransformNavigationCommands = (0, $eJOHy.useCallback)((commands)=>{
        const filteredCommands = [];
        commands.forEach((commandToTransform)=>{
            const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
            if (transformedCommand) filteredCommands.push(transformedCommand);
        });
        return filteredCommands;
    }, [
        hideAndTransformNavigationCommand
    ]);
    return {
        shouldShowCommand: shouldShowCommand,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
        transformNavigationCommand: transformNavigationCommand
    };
};
const $ae31bfa49fe3c190$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    height: '24px',
    width: '24px',
    marginLeft: 'space.075'
});

});
parcelRegister("jmeeg", function(module, exports) {
$parcel$export(module.exports, "components", () => $0452758bc49e816e$export$9b5ac10f59f76296);

var $eJOHy = parcelRequire("eJOHy");

var $dUOwK = parcelRequire("dUOwK");

var $2Nn1q = parcelRequire("2Nn1q");

var $lKFw0 = parcelRequire("lKFw0");

var $b4bRO = parcelRequire("b4bRO");
const $0452758bc49e816e$var$NameComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $0452758bc49e816e$export$9b5ac10f59f76296 = {
    CommandRow: // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
    $2Nn1q.CommandRow,
    Name: $0452758bc49e816e$var$NameComponent,
    LeftIcon: (0, $eJOHy.Fragment),
    Wrapper: (0, $eJOHy.Fragment),
    Footer: $lKFw0.Footer,
    Body: (0, $dUOwK.CommandPaletteBody),
    Header: $b4bRO.Header
};

});
parcelRegister("dUOwK", function(module, exports) {
$parcel$export(module.exports, "NoResultsContainer", () => $3a17c57ac1b263a3$export$2ab569a6937cb4e4);
$parcel$export(module.exports, "CommandPaletteBody", () => $3a17c57ac1b263a3$export$b1023de69a8756e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $58ssj = parcelRequire("58ssj");

var $ftN6c = parcelRequire("ftN6c");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $g51Bg = parcelRequire("g51Bg");

var $2OtIa = parcelRequire("2OtIa");

var $5Ywg0 = parcelRequire("5Ywg0");

var $g8Pqh = parcelRequire("g8Pqh");

var $iG2Hi = parcelRequire("iG2Hi");


var $aNkQT = parcelRequire("aNkQT");

var $OZurT = parcelRequire("OZurT");

var $6b4EO = parcelRequire("6b4EO");

var $5IbG4 = parcelRequire("5IbG4");
const $3a17c57ac1b263a3$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, $g51Bg.useCommandPalette)();
    const onHoverCommand = (0, $eJOHy.useCallback)((index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    }, [
        setActiveIndex
    ]);
    const onMouseDownCommand = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onClickCommand = (0, $eJOHy.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $2OtIa.getAnalyticsAttributesFromResult)(result),
                ...(0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $2OtIa.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const onClickKeyboardCommand = (0, $eJOHy.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'keyboard',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $2OtIa.getAnalyticsAttributesFromResult)(result),
                ...(0, $2OtIa.getRegistryData)(registry, activeRegistry, result.command.id)
            }
        }, (0, $58ssj.isMacOs)() ? event.metaKey : event.ctrlKey);
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    if ((0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        const handleEnterKey = (event)=>{
            if (event.key === 'Enter') {
                const focusedElement = typeof document !== 'undefined' ? document.activeElement : null;
                let targetElement = focusedElement;
                while(targetElement && targetElement !== (0, $fceQU.getDocument)()?.body){
                    if (targetElement.getAttribute('data-testid') === (0, $6b4EO.COMMAND_CONTAINER_ROW_TEST_ID)) {
                        event.preventDefault();
                        const focusedId = targetElement.id?.replace(`${(0, $19c39496d342d719$export$b28d6b416aaf953a)}-`, '');
                        if (focusedId) {
                            const selectedCommand = results.find((result)=>!result.isGroup && 'command' in result && result.command.id === focusedId);
                            if (selectedCommand) onClickKeyboardCommand(event, selectedCommand);
                        }
                        break;
                    }
                    targetElement = targetElement.parentElement;
                }
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleEnterKey);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleEnterKey);
        };
    }, [
        onClickKeyboardCommand,
        results
    ]);
    const localResultRefs = resultsRefs.current;
    const commandItem = (0, $eJOHy.useCallback)((result, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNkQT.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8Pqh.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OZurT.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        }))), [
        activeRegistry,
        isSearchFieldFocused,
        localResultRefs,
        onClickCommand,
        onHoverCommand,
        onMouseDownCommand,
        registry,
        removeCommandsById
    ]);
    const renderGroupedResults = (0, $eJOHy.useCallback)(()=>{
        const resultList = [];
        let groupList = [];
        const wrappedGroup = (group, groupIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                role: "group",
                "aria-labelledby": `group-heading-${groupIndex}`,
                key: `group-${groupIndex}`
            }, group);
        results.forEach((result, i)=>{
            if (result.isGroup) {
                if (groupList.length !== 0) {
                    resultList.push(wrappedGroup(groupList, resultList.length));
                    groupList = [];
                }
                groupList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ywg0.CommandPaletteSearchResultGroupItem), {
                    ref: (commandRef)=>{
                        if (commandRef) localResultRefs[i] = commandRef;
                    },
                    group: result.group,
                    key: i
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$GroupContainerComponent, {
                    as: "h2",
                    role: "presentation",
                    "data-testid": (0, $6b4EO.GROUP_TEST_ID),
                    isFirstResult: i === 0,
                    id: `group-heading-${resultList.length}`
                }, result.renderGroup ? result.renderGroup() : result.group)));
            } else groupList.push(commandItem(result, i));
        });
        if (groupList.length !== 0) resultList.push(wrappedGroup(groupList, resultList.length));
        return resultList;
    }, [
        commandItem,
        localResultRefs,
        results
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$export$2ab569a6937cb4e4, {
        "data-testid": (0, $6b4EO.NO_RESULTS_TEST_ID)
    }, noResultsFallback), (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') && renderGroupedResults(), !(0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') && results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ywg0.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            group: result.group,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$GroupContainerComponent, {
            as: "h2",
            role: "presentation",
            "data-testid": (0, $6b4EO.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNkQT.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8Pqh.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OZurT.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
const $3a17c57ac1b263a3$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, $g51Bg.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eJOHy.useState)(activeIndex);
    const resultsRefs = (0, $eJOHy.useRef)([]);
    const modalBodyRef = (0, $eJOHy.useRef)(null);
    const onArrowScroll = (0, $eJOHy.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $eJOHy.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $6b4EO.SCROLL_DIRECTION).END : (0, $6b4EO.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $5IbG4.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $5IbG4.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $5IbG4.scrollResultIntoView)({
                target: scrolledToResult,
                direction: scrollTo,
                scrollContainer: modalBodyRef.current
            });
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eJOHy.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iG2Hi.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        noResultsFallback: noResultsFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$CommandPaletteChildren, {
        results: results,
        noResultsFallback: noResultsFallback,
        renderAfterCommands: renderAfterCommands,
        resultsRefs: resultsRefs
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a17c57ac1b263a3$var$GroupContainerComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $awdRS.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1yt41f6d _syaz131l",
            __cmplp.className
        ])
    });
});
const $3a17c57ac1b263a3$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _syaz131l _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Ywg0", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $2dc004120872e887$export$591c26128e5fd757);

var $eJOHy = parcelRequire("eJOHy");

const $2dc004120872e887$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        "data-testid": (0, $19c39496d342d719$export$617744f059bfc3ba),
        id: group ? `${0, $19c39496d342d719$export$9ed1834ff36a8f29}-${group}` : undefined,
        ...rest
    }));

});
const $19c39496d342d719$export$9ffb4923f81813d9 = 'compal-menu';
const $19c39496d342d719$export$b28d6b416aaf953a = `${$19c39496d342d719$export$9ffb4923f81813d9}-item`;
const $19c39496d342d719$export$9ed1834ff36a8f29 = `${$19c39496d342d719$export$9ffb4923f81813d9}-group`;
const $19c39496d342d719$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $19c39496d342d719$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $19c39496d342d719$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $19c39496d342d719$export$9e40a0642460a944 = 'compal-menu-screen-reader';


parcelRegister("g8Pqh", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $1fa300fadfc2263f$export$1f8fa9d1eef77b32);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");


var $bZFaG = parcelRequire("bZFaG");
const $1fa300fadfc2263f$var$styles = {
    root: "_bozg1b66 _y4ti1b66"
};
const $1fa300fadfc2263f$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ id: id, active: active, selected: selected, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        "data-testid": (0, $19c39496d342d719$export$617744f059bfc3ba),
        "aria-current": (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') ? undefined : active,
        role: (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') ? 'option' : 'menuitem',
        "aria-selected": selected,
        id: `${(0, $19c39496d342d719$export$b28d6b416aaf953a)}-${id}`,
        "aria-label": formatMessage((0, $bZFaG.messages).resultListItemAriaLabel),
        ...(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility') && {
            css: $1fa300fadfc2263f$var$styles.root
        },
        ...rest
    });
});

});
parcelRegister("bZFaG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1a66dcc5b190c609$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1a66dcc5b190c609$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    resultListItemAriaLabel: {
        "id": "command-palette.common.command-palette-search-result-list-item",
        "defaultMessage": "Command palette action item"
    }
});

});


parcelRegister("iG2Hi", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $6725cef9016fe1d5$export$95554f6fb39a83c2);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");


var $1XCAD = parcelRequire("1XCAD");

var $2pUb3 = parcelRequire("2pUb3");
const $6725cef9016fe1d5$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resizerRef = (0, $eJOHy.useRef)(null);
    const height = (0, $2pUb3.useSmoothExpand)(resizerRef);
    (0, $eJOHy.useEffect)(()=>{
        if (ref && 'current' in ref && ref.current) {
            const currentRef = ref.current;
            currentRef.style.height = `${height}px`;
        }
    }, [
        height,
        ref
    ]);
    const resultsRole = (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') ? 'listbox' : 'menu';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6725cef9016fe1d5$var$wrapperStyles,
        testId: (0, $19c39496d342d719$export$85eefac753ab5bdb),
        id: (0, $19c39496d342d719$export$9ffb4923f81813d9),
        role: noResultsFallback ? 'group' : resultsRole,
        ref: ref,
        "aria-label": formatMessage((0, $1XCAD.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        ref: resizerRef,
        direction: "column",
        gap: "space.050"
    }, children));
});
const $6725cef9016fe1d5$var$wrapperStyles = (0, $1DXK0.xcss)({
    padding: '0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    transition: 'height 0.15s ease-out',
    overflowY: 'auto',
    maxHeight: '376px'
});

});
parcelRegister("1XCAD", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5f9181ddee7f41b1$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5f9181ddee7f41b1$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});

parcelRegister("2pUb3", function(module, exports) {
$parcel$export(module.exports, "useSmoothExpand", () => $535f9e4bd6cd6e9a$export$674ba8b02d2bfe86);

var $eJOHy = parcelRequire("eJOHy");
const $535f9e4bd6cd6e9a$var$MAX_HEIGHT = 376;
const $535f9e4bd6cd6e9a$var$STARTING_HEIGHT = 56;
const $535f9e4bd6cd6e9a$var$ADDITIONAL_HEIGHT = 16;
const $535f9e4bd6cd6e9a$export$674ba8b02d2bfe86 = (content)=>{
    const [height, setHeight] = (0, $eJOHy.useState)($535f9e4bd6cd6e9a$var$STARTING_HEIGHT);
    const callback = (0, $eJOHy.useCallback)(()=>{
        const contentClientHeight = content.current?.clientHeight;
        if (!contentClientHeight) return;
        if (contentClientHeight > $535f9e4bd6cd6e9a$var$MAX_HEIGHT) setHeight($535f9e4bd6cd6e9a$var$MAX_HEIGHT);
        else setHeight(contentClientHeight + $535f9e4bd6cd6e9a$var$ADDITIONAL_HEIGHT);
    }, [
        content
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let resizeObserver;
        if (content.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(content.current);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        callback,
        content
    ]);
    return height;
};

});


parcelRegister("aNkQT", function(module, exports) {
$parcel$export(module.exports, "CommandRowErrorBoundary", () => $396c9e18c0709720$export$223f3c3c93a14a83);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");
const $396c9e18c0709720$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("OZurT", function(module, exports) {
$parcel$export(module.exports, "CommandRow", () => $7150d313297e5fc3$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $2OtIa = parcelRequire("2OtIa");

var $2Nn1q = parcelRequire("2Nn1q");
const $7150d313297e5fc3$var$styles = {
    rowWrapper: "_bozg1b66 _y4ti1b66"
};
const $7150d313297e5fc3$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        ...(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility') && {
            isLinkFocused: !!command.components?.CommandRow
        },
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $2OtIa.getAnalyticsAttributesFromResult)(result)
    };
    if ((0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $7150d313297e5fc3$var$styles.rowWrapper
        ])
    }, command.components?.CommandRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.CommandRow, rowProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Nn1q.CommandRow), rowProps));
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Nn1q.CommandRow), rowProps);
};

});
parcelRegister("2Nn1q", function(module, exports) {
$parcel$export(module.exports, "CommandRow", () => $23485c420ee6846d$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $46R8N = parcelRequire("46R8N");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $1k1Uh = parcelRequire("1k1Uh");


var $cSwEo = parcelRequire("cSwEo");

var $gXsfJ = parcelRequire("gXsfJ");
const $23485c420ee6846d$var$activeStyles = null;
const $23485c420ee6846d$var$leftIconAndNameContainerStyles = null;
const $23485c420ee6846d$var$outlinedLozengeStyles = null;
const $23485c420ee6846d$var$styles = {
    root: "_1bsb1osq",
    commandContainer: "_11c82smr _syaz1gjq _1q511b66 _85i51b66 _bozg1b66 _y4ti1b66 _ahbqr5cr _12l2r5cr",
    innerContainer: "_1q511b66 _85i51b66 _bozgpxbi _y4tipxbi _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
    iconsContainer: "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
    buttonWrapper: "_bozg1b66 _y4ti1b66",
    button: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _bfhk18uv _y3gn1e5h"
};
const $23485c420ee6846d$export$3ef5d254c3c573e3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, ...rest }, ref)=>{
    const InnerContainer = $23485c420ee6846d$var$CommandContainerInner;
    if (!(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $f844ecf9ba7020db$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InnerContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$47c379a40b00a339),
        ref: ref,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandIconsContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $23485c420ee6846d$var$iconStyles,
            isActive && $23485c420ee6846d$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1k1Uh.OutlinedLozenge), {
        "data-testid": (0, $f844ecf9ba7020db$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSwEo.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXsfJ.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": command.id,
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-active": isActive,
        "data-testid": (0, $f844ecf9ba7020db$export$b0017db5728101cc),
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.commandContainer,
            isActive && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$47c379a40b00a339),
        ref: ref,
        ...rest,
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.innerContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$d6dd1cf63aae711c),
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.iconsContainer
        ])
    }, command.components?.LeftIcon && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $23485c420ee6846d$var$iconStyles,
            isActive && $23485c420ee6846d$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$72c5368f559dd523),
        className: (0, $hcewu.default)([
            "_2rko12b0 _11c81u0j _19it3ju0 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _k48p1pd9 _bfhk1j9a _syaz131l _vchhusvi"
        ])
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSwEo.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXsfJ.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
    if (command.components?.CommandRow) return content;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46R8N.default), {
        xcss: $23485c420ee6846d$var$styles.button,
        "aria-label": command.name
    }, content);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23485c420ee6846d$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _syaz1gjq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            !!__cmplp.active && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandContainerInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandIconsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$iconStyles = (0, $1DXK0.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $23485c420ee6846d$var$iconActiveStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23485c420ee6846d$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syazwdcn" : "_syaz1oju",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1k1Uh", function(module, exports) {
$parcel$export(module.exports, "OutlinedLozenge", () => $34fe5e771f897e84$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $34fe5e771f897e84$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $34fe5e771f897e84$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $34fe5e771f897e84$var$Lozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx3fajl _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

const $f844ecf9ba7020db$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $f844ecf9ba7020db$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $f844ecf9ba7020db$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $f844ecf9ba7020db$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $f844ecf9ba7020db$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("cSwEo", function(module, exports) {
$parcel$export(module.exports, "RenderCommandName", () => $d68023b12b2300be$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cQxBL = parcelRequire("cQxBL");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");

var $eZyz9 = parcelRequire("eZyz9");

const $d68023b12b2300be$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eJOHy.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eZyz9.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandNameContainer, {
        "data-testid": (0, $726ded7d34812919$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $726ded7d34812919$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $726ded7d34812919$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            justifyContent: "center",
            xcss: $d68023b12b2300be$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $726ded7d34812919$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandChevronContainer, {
            "data-testid": (0, $726ded7d34812919$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d68023b12b2300be$var$CommandNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_dm2rwo": (0, $awdRS.default)(__cmplp.active ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !!__cmplp.isParent && "_syazalb7",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandChevronContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4kb7n _syaz1oju",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    height: '24px',
    width: '24px'
});

});
parcelRegister("eZyz9", function(module, exports) {
$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $0485cf2ed2b26536$export$4495aca3d261add0);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $IW7jS = parcelRequire("IW7jS");

var $8nMzv = parcelRequire("8nMzv");

var $i92Id = parcelRequire("i92Id");


var $fu9LY = parcelRequire("fu9LY");
const $0485cf2ed2b26536$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        messageId: "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.popup",
        messageType: "transactional",
        popupComponent: (0, $i92Id.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $IW7jS.layers).tooltip()
    });
const $0485cf2ed2b26536$export$70f47de153e915ed = ()=>(0, $eJOHy.useRef)(null);
const $0485cf2ed2b26536$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $0485cf2ed2b26536$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $fu9LY.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $4c1f11f798b8ffde$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: containerRef,
        xcss: [
            $0485cf2ed2b26536$var$tooltipContainerStyles,
            !preventTruncate && $0485cf2ed2b26536$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0485cf2ed2b26536$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $0485cf2ed2b26536$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $0485cf2ed2b26536$var$truncateTooltipStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("i92Id", function(module, exports) {
$parcel$export(module.exports, "TooltipComponent", () => $849f6edf3f22b0d2$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $849f6edf3f22b0d2$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $849f6edf3f22b0d2$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $849f6edf3f22b0d2$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $849f6edf3f22b0d2$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $849f6edf3f22b0d2$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7AseU = parcelRequire("7AseU");

var $lRq8t = parcelRequire("lRq8t");

var $ccaPK = parcelRequire("ccaPK");
const $849f6edf3f22b0d2$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $849f6edf3f22b0d2$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $ccaPK.messages).tooltipTriggerAriaLabel)
    });
});
const $849f6edf3f22b0d2$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $849f6edf3f22b0d2$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $7AseU.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $849f6edf3f22b0d2$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswh2mm _o5721q9c _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ccaPK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c726bd5d325f45ec$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c726bd5d325f45ec$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $4c1f11f798b8ffde$export$f9e3e7ede9ba929d = 400;

parcelRegister("fu9LY", function(module, exports) {
$parcel$export(module.exports, "useTruncatedTooltip", () => $696d52b07491914e$export$94b118b3187f12c);

var $eJOHy = parcelRequire("eJOHy");

var $2OtIa = parcelRequire("2OtIa");
const $696d52b07491914e$export$22c0312879c61300 = ()=>(0, $eJOHy.useState)(false);
const $696d52b07491914e$export$1ac6e474a0163418 = ()=>(0, $eJOHy.useState)(false);
const $696d52b07491914e$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $696d52b07491914e$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $696d52b07491914e$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $2OtIa.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eJOHy.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $726ded7d34812919$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $726ded7d34812919$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $726ded7d34812919$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $726ded7d34812919$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("gXsfJ", function(module, exports) {
$parcel$export(module.exports, "RightContent", () => $36c01c052dc4602a$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cQxBL = parcelRequire("cQxBL");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2OtIa = parcelRequire("2OtIa");


var $xZyb9 = parcelRequire("xZyb9");

var $ivvUQ = parcelRequire("ivvUQ");

var $d6dCH = parcelRequire("d6dCH");

var $i7euV = parcelRequire("i7euV");
const $36c01c052dc4602a$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const transitionStep = (0, $i7euV.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eJOHy.useMemo)(()=>(0, $2OtIa.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$CommandRightChevronContainer, {
        "data-testid": (0, $f29cb9aaec65a024$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        spacing: "spacious",
        label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $xZyb9.messages).rightChevronLabel),
        size: "small",
        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$ShortcutContainer, {
        "data-testid": (0, $f29cb9aaec65a024$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivvUQ.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $36c01c052dc4602a$var$animationFadeIn = null;
const $36c01c052dc4602a$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$RightContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syaz1oju",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$ShortcutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
const $f29cb9aaec65a024$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $f29cb9aaec65a024$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';

parcelRegister("xZyb9", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8f4e2b0de24497ce$export$defe85febe8b728c);
// Delete file when cleaning up deliveroo_compal_a11y_fixes

var $7qGN1 = parcelRequire("7qGN1");
const $8f4e2b0de24497ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("ivvUQ", function(module, exports) {
$parcel$export(module.exports, "Shortcuts", () => $2bdae852387b780f$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $cMTOh = parcelRequire("cMTOh");

var $2OtIa = parcelRequire("2OtIa");


var $ey2FZ = parcelRequire("ey2FZ");
const $2bdae852387b780f$var$KeyElement = ({ shortcut: shortcut })=>{
    const isLongText = shortcut && shortcut.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $2bdae852387b780f$var$styles.shortcutKeyWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $09f953b7673081a6$export$cd62afa4691c297),
        className: (0, $hcewu.default)([
            $2bdae852387b780f$var$styles.lozenge,
            isLongText && $2bdae852387b780f$var$styles.longLozenge
        ])
    }, shortcut));
};
const $2bdae852387b780f$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$ShortcutDivider, {
        "data-testid": (0, $09f953b7673081a6$export$e06ad7c09a29974b)
    }, divisor);
const $2bdae852387b780f$var$SHIFT_CHAR_MAP = {
    '?': 'shift /',
    '!': 'shift 1',
    '@': 'shift 2',
    '#': 'shift 3',
    $: 'shift 4',
    '%': 'shift 5',
    '^': 'shift 6',
    '&': 'shift 7',
    '*': 'shift 8',
    '(': 'shift 9',
    ')': 'shift 0',
    _: 'shift -',
    '+': 'shift =',
    '{': 'shift [',
    '}': 'shift ]',
    ':': 'shift ;',
    '"': "shift '",
    '<': 'shift ,',
    '>': 'shift .',
    '|': 'shift \\',
    '~': 'shift `'
};
const $2bdae852387b780f$var$shiftModifierCheck = (shortcut)=>{
    if (shortcut.length === 1) {
        if (/[A-Z]/.test(shortcut)) return `shift ${shortcut.toLowerCase()}`;
        return $2bdae852387b780f$var$SHIFT_CHAR_MAP[shortcut] || shortcut;
    }
    return shortcut;
};
const $2bdae852387b780f$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        $2bdae852387b780f$var$shiftModifierCheck(shortcut).split(' ').forEach((key, index, array)=>{
            acc.push({
                type: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY,
                key: key
            });
            types.push((0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY);
            if (index < array.length - 1) {
                const separatorType = (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS;
                acc.push({
                    type: separatorType
                });
                types.push(separatorType);
            }
        });
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $2bdae852387b780f$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $2bdae852387b780f$export$cfaeb054b183bb20 = ()=>(0, $lRq8t.default)();
const $2bdae852387b780f$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $2bdae852387b780f$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eJOHy.useMemo)(()=>$2bdae852387b780f$var$parseShortcut(shortcut, (0, $2OtIa.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eJOHy.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ey2FZ.messages).shortcutThen;
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ey2FZ.messages).shortcutOr;
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ey2FZ.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eJOHy.useCallback)((type)=>{
        switch(type){
            case (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ey2FZ.messages).divisorThen);
            case (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ey2FZ.messages).divisorOr);
            default:
                return formatMessage((0, $ey2FZ.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$ShortcutContainer, {
        "data-testid": (0, $09f953b7673081a6$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bdae852387b780f$var$ShortcutDivider = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bdae852387b780f$var$ShortcutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2bdae852387b780f$var$styles = {
    lozenge: "_2rko12b0 _11c81u0j _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3i1tcg _syaz1fxt _1ul91tcg _1bsb1ris _kqswh2mm _1p1d1dk0 _1pbykb7n _1s6krwve _rfx312b0 _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
    longLozenge: "_18zr12x7",
    shortcutKeyWrapper: "_ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};

});
const $09f953b7673081a6$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $09f953b7673081a6$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $09f953b7673081a6$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ey2FZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e4fcfaa38e4e2d0e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e4fcfaa38e4e2d0e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("d6dCH", function(module, exports) {
$parcel$export(module.exports, "TRANSITION_STEP", () => $b2e6d0fa9dbab6a6$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $b2e6d0fa9dbab6a6$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $b2e6d0fa9dbab6a6$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $b2e6d0fa9dbab6a6$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $b2e6d0fa9dbab6a6$export$42d8d7c94c5a11e9 = /*#__PURE__*/ function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    return TRANSITION_STEP;
}({});
const $b2e6d0fa9dbab6a6$export$82cfc253a6c33f59 = 600;
const $b2e6d0fa9dbab6a6$export$e092796a9af3633b = 300;
const $b2e6d0fa9dbab6a6$export$1cad4f611a1c0229 = 350;

});

parcelRegister("i7euV", function(module, exports) {
$parcel$export(module.exports, "useHoverTransitionStep", () => $f0a4c8d4492da351$export$eefd045a02bab4c6);

var $eJOHy = parcelRequire("eJOHy");

var $kk5YU = parcelRequire("kk5YU");

var $9pTd3 = parcelRequire("9pTd3");

var $2OtIa = parcelRequire("2OtIa");

var $d6dCH = parcelRequire("d6dCH");
const $f0a4c8d4492da351$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eJOHy.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eJOHy.useState)((0, $d6dCH.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eJOHy.useRef)(null);
    const isReducedMotion = (0, $kk5YU.useIsReducedMotion)();
    const commandHasChildren = (0, $2OtIa.hasChildren)(command);
    (0, $eJOHy.useEffect)(()=>{
        setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eJOHy.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $d6dCH.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eJOHy.useCallback)(()=>{
        switch(transitionStep){
            case (0, $d6dCH.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $d6dCH.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $d6dCH.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $d6dCH.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).FINISHED, (0, $d6dCH.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $d6dCH.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).INITIAL, (0, $d6dCH.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $9pTd3.fireErrorAnalytics)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isFirstCommand) // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
        setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});




parcelRegister("6b4EO", function(module, exports) {
$parcel$export(module.exports, "COMMAND_CONTAINER_ROW_TEST_ID", () => $354f8ec6615134bc$export$617744f059bfc3ba);
$parcel$export(module.exports, "GROUP_TEST_ID", () => $354f8ec6615134bc$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $354f8ec6615134bc$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $354f8ec6615134bc$export$a6d65a8fb7b912d6);
const $354f8ec6615134bc$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $354f8ec6615134bc$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $354f8ec6615134bc$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $354f8ec6615134bc$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $354f8ec6615134bc$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $354f8ec6615134bc$export$a6d65a8fb7b912d6 = /*#__PURE__*/ function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
    return SCROLL_DIRECTION;
}({});

});

parcelRegister("5IbG4", function(module, exports) {
$parcel$export(module.exports, "isElementVisibleInContainer", () => $a1ee1680b73743ba$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $a1ee1680b73743ba$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $a1ee1680b73743ba$export$6be8a7238febd54f);

var $2OtIa = parcelRequire("2OtIa");

var $6b4EO = parcelRequire("6b4EO");
const $a1ee1680b73743ba$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $a1ee1680b73743ba$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $6b4EO.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $2OtIa.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $6b4EO.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $2OtIa.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $a1ee1680b73743ba$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
    const targetRect = target.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const gapScroll = 4;
    if (direction === (0, $6b4EO.SCROLL_DIRECTION).END) {
        const commandPosition = targetRect.bottom - containerRect.top;
        const amountToScroll = commandPosition - containerRect.height;
        const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
        scrollContainer.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = containerRect.top - targetRect.top;
        const amountToScroll = scrollContainer.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollContainer.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("lKFw0", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $0deb62bf7e6b3b6e$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");

var $4cTDP = parcelRequire("4cTDP");

const $0deb62bf7e6b3b6e$var$styles = {
    root: "_1e0c1txw _4cvr1h6o _mrkb1kw7 _1o0z1kw7 _1i53muej _uwhke4h9 _15a5nqa1 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi _4t3ickbl"
};
const $0deb62bf7e6b3b6e$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    if ((0, $4cTDP.fg)('compal_jifjam_navigation_new_filters')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $0deb62bf7e6b3b6e$var$styles.root,
        testId: (0, $19b63b11e263f76d$export$aca3e1b45b29f2bb)
    }, footerChildren);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0deb62bf7e6b3b6e$var$ModalFooterOld, {
        "data-testid": (0, $19b63b11e263f76d$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0deb62bf7e6b3b6e$var$ModalFooterOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _mrkb1kw7 _1o0z1kw7 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
const $19b63b11e263f76d$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("b4bRO", function(module, exports) {
$parcel$export(module.exports, "Header", () => $6a7be27086db7192$export$8b251419efc915eb);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

const $6a7be27086db7192$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6a7be27086db7192$var$headerStyles,
        testId: (0, $dea6840b8c2241ed$export$bf5b960a2e79e6cf)
    }, children);
const $6a7be27086db7192$var$headerStyles = (0, $1DXK0.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    borderBottom: `solid 1px ${"var(--ds-border, #091E4224)"}`
});

});
const $dea6840b8c2241ed$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("7rOkc", function(module, exports) {
$parcel$export(module.exports, "NameContainer", () => $cbc9be426e5acea2$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "IconContainer", () => $cbc9be426e5acea2$export$8f314e512d92575f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $cbc9be426e5acea2$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
            __cmplp.className
        ])
    });
});
const $cbc9be426e5acea2$export$8f314e512d92575f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cZPxL", function(module, exports) {
$parcel$export(module.exports, "NavigationLink", () => $9a70486e486be526$export$721ee963a67379f1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $c9uTK = parcelRequire("c9uTK");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");
const $9a70486e486be526$var$styles = {
    link: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1e0c1ule _9oik18uv _1bnxglyw _jf4cnqa1",
    linkFocused: "_y2mvugt7 _1bg4v77o _jomr18uv"
};
const $9a70486e486be526$export$81dde5c31917bf6 = ({ isLinkFocused: isLinkFocused, children: children, ...props })=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $c9uTK.Link), {
        ...props,
        className: (0, $hcewu.default)([
            $9a70486e486be526$var$styles.link,
            isLinkFocused && $9a70486e486be526$var$styles.linkFocused
        ])
    }, children);
};
const $9a70486e486be526$export$a52a4e5f5bc2fe3f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $c9uTK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $9a70486e486be526$export$721ee963a67379f1 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility'), $9a70486e486be526$export$81dde5c31917bf6, $9a70486e486be526$export$a52a4e5f5bc2fe3f);

});

parcelRegister("9LFHG", function(module, exports) {
$parcel$export(module.exports, "NewTabHintMessage", () => $06af5dadddd8ab87$export$54561b2030abf061);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58ssj = parcelRequire("58ssj");

var $8IeH1 = parcelRequire("8IeH1");

var $jmeeg = parcelRequire("jmeeg");

var $1k1Uh = parcelRequire("1k1Uh");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $i2qT7 = parcelRequire("i2qT7");
const $06af5dadddd8ab87$var$styles = {
    footerContentContainer: "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq"
};
const $06af5dadddd8ab87$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const footerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, defaultFooterContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$HintMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$MessageWrapper, null, formatMessage((0, $i2qT7.messages).openInANewTab)), (0, $58ssj.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$MacLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$MacTextOffset, null, "\u2318")) : // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$WindowsLozenge, null, "Ctrl"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$EnterLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$EnterIconSVG, null))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmeeg.components).Footer, null, (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $06af5dadddd8ab87$var$styles.footerContentContainer,
        testId: "command-palette-common.common.ui.new-tab-hint-message"
    }, footerContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$FooterContentContainerOld, {
        "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
    }, footerContent));
};
const $06af5dadddd8ab87$var$EnterIconSVG = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
        fill: "var(--ds-text-subtle, #44546F)"
    })); // Delete when cleaning up compal_jifjam_navigation_new_filters
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$FooterContentContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$HintMessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m _syaz1gjq _u5f312x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$MacLozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $1k1Uh.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81ixg _18u0v77o _vwz47vkz _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$MacTextOffset = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_t9ec170z",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$WindowsLozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $1k1Uh.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1qjk _k48pi7a9 _1p1d1dk0 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$EnterLozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $1k1Uh.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
const $06af5dadddd8ab87$var$MessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i2qT7", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fa31b2a866287d43$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fa31b2a866287d43$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    openInANewTab: {
        "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
        "defaultMessage": "Open in a new tab"
    }
});

});


parcelRegister("aUXni", function(module, exports) {
$parcel$export(module.exports, "isCurrentPage", () => $9787bcf805f7e6d3$export$d4781f4a7d66b55c);
const $9787bcf805f7e6d3$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
    const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
    const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
    return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
};

});

const $5c6484dc0a85adf4$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $5c6484dc0a85adf4$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';


const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = 368;

parcelRegister("5Ste8", function(module, exports) {
$parcel$export(module.exports, "ModalsContainer", () => $17059759b478c401$export$5dffa5a5319be22d);
$parcel$export(module.exports, "ModalsSubscriber", () => $17059759b478c401$export$facc296933ebcadf);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $ht3nQ = parcelRequire("ht3nQ");

var $lezjz = parcelRequire("lezjz");
const $17059759b478c401$export$5dffa5a5319be22d = (0, $6E16M.createContainer)((0, $lezjz.default));
const $17059759b478c401$export$facc296933ebcadf = (0, $ht3nQ.createSubscriber)((0, $lezjz.default), {
    displayName: 'ModalsSubscriber',
    selector: (state)=>state.isOpen
});

});
parcelRegister("lezjz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a024ebd7ef786d8$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $139Z7 = parcelRequire("139Z7");
const $7a024ebd7ef786d8$var$initialState = {
    isOpen: false
};
var $7a024ebd7ef786d8$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'modals',
    initialState: $7a024ebd7ef786d8$var$initialState,
    actions: $139Z7.default
});

});
parcelRegister("139Z7", function(module, exports) {
$parcel$export(module.exports, "default", () => $15892008fa8602a9$export$2e2bcd8739ae039);
const $15892008fa8602a9$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
var $15892008fa8602a9$export$2e2bcd8739ae039 = $15892008fa8602a9$var$actions;

});



const $2e00a4e32dbdece8$export$e0515b3bb1ce3f33 = 'viewKeyboardShortcuts';
const $2e00a4e32dbdece8$export$5f007fc3736b8e2b = 'viewAllIssues';
const $2e00a4e32dbdece8$export$4e353cf4f7beb2cd = 'createIssue';
const $2e00a4e32dbdece8$export$42dbd0c9d165bb55 = 'getHelp';

parcelRegister("52o2P", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec07c11f41c0df0f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $ec07c11f41c0df0f$var$messages = (0, $7qGN1.defineMessages)({
    globalShortcuts: {
        "id": "keyboard-shortcuts.global-shortcuts",
        "defaultMessage": "Global shortcuts"
    },
    quickSearch: {
        "id": "keyboard-shortcuts.quick-search",
        "defaultMessage": "Quick search"
    },
    closeDrawer: {
        "id": "keyboard-shortcuts.close-drawer",
        "defaultMessage": "Close drawer"
    },
    createIssue: {
        "id": "keyboard-shortcuts.create-issue",
        "defaultMessage": "Create issue"
    },
    keyboardShortcuts: {
        "id": "keyboard-shortcuts.keyboard-shortcuts",
        "defaultMessage": "Keyboard shortcuts"
    },
    keyboardShortcutsCommandPalette: {
        "id": "keyboard-shortcuts.keyboard-shortcuts-command-palette",
        "defaultMessage": "View keyboard shortcuts"
    },
    findIssues: {
        "id": "keyboard-shortcuts.find-issues",
        "defaultMessage": "Find issues"
    },
    browseAProject: {
        "id": "keyboard-shortcuts.browse-a-project",
        "defaultMessage": "Browse to a project"
    },
    toggleSidebar: {
        "id": "keyboard-shortcuts.toggle-sidebar",
        "defaultMessage": "Toggle sidebar"
    },
    openHelpPanel: {
        "id": "keyboard-shortcuts.open-help-panel",
        "defaultMessage": "Open help panel"
    },
    openCommandPalette: {
        "id": "keyboard-shortcuts.open-command-palette",
        "defaultMessage": "Open command palette"
    },
    quickSearchCommand: {
        "id": "keyboard-shortcuts.quick-search-command",
        "defaultMessage": "Open quick search"
    },
    getHelp: {
        "id": "keyboard-shortcuts.get-help",
        "defaultMessage": "Get help"
    },
    viewAllIssues: {
        "id": "keyboard-shortcuts.view-all-issues",
        "defaultMessage": "View all issues"
    },
    createIssueIssueTermRefresh: {
        "id": "keyboard-shortcuts.create-issue-issue-term-refresh",
        "defaultMessage": "Create work item"
    },
    findIssuesIssueTermRefresh: {
        "id": "keyboard-shortcuts.find-issues-issue-term-refresh",
        "defaultMessage": "Find work items"
    },
    viewAllIssuesIssueTermRefresh: {
        "id": "keyboard-shortcuts.view-all-issues-issue-term-refresh",
        "defaultMessage": "View all work items"
    },
    browseAProjectGalaxia: {
        "id": "keyboard-shortcuts.browse-a-project-galaxia",
        "defaultMessage": "Browse to a space"
    }
});
var $ec07c11f41c0df0f$export$2e2bcd8739ae039 = $ec07c11f41c0df0f$var$messages;

});

parcelRegister("2UiCp", function(module, exports) {
$parcel$export(module.exports, "getShortcutModifierKey", () => $824b108968c55c0c$export$fe66dae91c68619b);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $824b108968c55c0c$var$isMacOs = ()=>/Mac/i.test(window?.navigator?.platform);
const $824b108968c55c0c$export$fe66dae91c68619b = ()=>$824b108968c55c0c$var$isMacOs() ? 'meta' : 'ctrl';

});




//# sourceMappingURL=async-keyboard-shortcuts-mapping.37fdc064.js.map
